import ActionBar from 'pages/Business/ActionBar';
import React from 'react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import ListUserBusiness from './ListUserBusiness';

const BusinessPage = () => {
  return (
    <div>
      <SemanticToastContainer position="top-right" />
      <h1>Business list</h1>
      <br />
      <ActionBar />
      <ListUserBusiness />
      <br />
    </div>
  );
};

export default BusinessPage;
